import { Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import Photos from "../../main/photos/page";
import ViewFolder from "../../main/photos/components/viewFolder";

const photosRoute = [
  {
    path: "/photos",
    element: <Photos />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.PHOTOS,
    // subModule: SUB_MODULES_LIST.PHOTOS.VIEW_PHOTOS,
  },
  {
    path: "/photos/:id",
    element: <ViewFolder />,
    // access: [
    //   COMMON_PERMISSIONS.VIEW,
    //   COMMON_PERMISSIONS.CREATE,
    //   COMMON_PERMISSIONS.UPDATE,
    // ],
    // module: MODULES_LIST.PHOTOS,
    // subModule: SUB_MODULES_LIST.PHOTOS.VIEW_PHOTOS,
  },
];

export default function renderPhotosRoutes() {
  const renderRoute = (route, access = false) => {
    if (route.children && route.children.length > 0) {
      return (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              access={route.access}
              path={route.path}
            >
              {route.element}
            </ProtectedRoute>
          }
        >
          {/* Render child routes without extra permission checks */}
          {route.children.map((child) => (
            <Route key={child.path} path={child.path} element={child.element} />
          ))}
        </Route>
      );
    }
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          access ? (
            route.element
          ) : (
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              access={route.access}
              path={route.path}
            >
              {route.element}
            </ProtectedRoute>
          )
        }
      />
    );
  };
  return photosRoute.map((route) => renderRoute(route));
}
